import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ScrAuthenticationService } from './authentication.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DecodedToken } from './authorization.service';
@Injectable({
  providedIn: 'root'
})
export class ScrAuthorizationGuard implements CanActivate {

  private jwtHelper = new JwtHelperService();

  constructor(
    private router: Router,
    private authenticationService: ScrAuthenticationService
  ) {

  }
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {

    let rv = false;
    const tok = await this.authenticationService.getIdToken();
    if (tok) {
      const decoded = this.jwtHelper.decodeToken<DecodedToken>(tok);
      if (decoded) {
        const groups = decoded['cognito:groups'] as string[];
        if (groups) {
          if (Array.isArray(route.data?.groups[0])) {
            route.data.groups.forEach((group: string[]) => {
              if (group.every((val: string) => groups.includes(val))) {
                rv = true;
              }
            });
          }
          else {
            rv = route.data.groups.some((grp: string) => groups.includes(grp));
          }
        }
      }
    }
    if (!rv) {
      this.router.navigate(['dashboard', { outlets: { 'navbar-tab': ['unauthorized'] } }], { replaceUrl: true });
    }
    return rv;
  }
}


@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(
    private authenticationService: ScrAuthenticationService,
    private logger: NGXLogger) {

  }

  /**
   * Returns true if the user is logged in.
   * If false, the requested URL is saved and the user is routed to the login page.
   *
   * @param route - route to be activated.
   * @param state - router state.
   */
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    const signedIn = await this.authenticationService.userIsSignedIn();
    if (!signedIn) {
      if ('/' !== state.url) {
        this.logger.debug('saving route to ' + state.url + ' and routing to login');
        this.authenticationService.redirectUrl = state.url;
      }
      else {
        this.logger.debug('routing to login');
      }
      this.authenticationService.login();
    }
    return signedIn;
  }
}
